import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import App from './App';
import Login from './components/Login';
import Callback from './components/Callback';
import ProtectedRoute from './components/ProtectedRoute';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/callback" element={<Callback />} />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <App />
            </ProtectedRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

// PWA 서비스 워커 등록 with update callback
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    // Custom event to notify App component
    const event = new CustomEvent('serviceWorkerUpdate', {
      detail: { registration }
    });
    window.dispatchEvent(event);
  },
  onSuccess: (registration) => {
    console.log('Service Worker registered successfully');
  }
});

// 성능 측정
reportWebVitals();
